import axios, { AxiosError } from "axios";

export async function getUserPhoto48Url(
  bearerToken: string,
  callback: any = null
) {
  if (bearerToken === "") {
    return;
  }

  try {
    await msGraphClient(bearerToken)
      .then((client) => client.getUserPhoto48Url())
      .then((blob: any) => {
        window.URL = window.URL || window.webkitURL;
        const blobUrl = window.URL.createObjectURL(blob);
        callback && callback(blobUrl);
      });
  } catch (error) {
    callback && callback(null);
  }
}

const msGraphClient = async (bearerToken: string) => {
  let hostUrl = "https://graph.microsoft.com/v1.0";
  let axiosInstance = axios.create();
  axiosInstance.interceptors.request.use((configuration) => {
    if (configuration && configuration.headers) {
      configuration.headers["Authorization"] = "Bearer " + bearerToken;
      configuration.headers["Accept"] = "application/json";
      configuration.headers["Content-Type"] = "image/jpg";
      configuration.headers["Access-Control-Allow-Origin"] = "*";
      configuration.headers["Access-Control-Allow-Headers"] = "*";
    }
    return configuration;
  });

  return new MsGraphProxy(hostUrl, axiosInstance);
};

export const rethrowError = (error: any) => {
  throw new AxiosError(error?.cause?.message ?? "Unexpected Client Error");
};

class MsGraphProxy {
  private hostUrl: string;
  private axiosInstance: any;

  constructor(hostUrl: string, axiosInstance: any) {
    this.hostUrl = hostUrl;
    this.axiosInstance = axiosInstance;
  }

  async getUserPhoto48Url() {
    const url = `${this.hostUrl}/me/photo/$value`;
    return this.axiosInstance
      .get(url, { responseType: "blob" })
      .then((response: any) => {
        return response.data;
      });
  }
}
